import { rbacService } from './rbacService';
import { normalizeProfile, normalizeProfileList } from '../utils/normalizeProfile';

export const profileService = {
  async getProfiles({ search = '', page = 0, limit = 20, organisationId = '' } = {}) {
    const res = await rbacService.getProfiles({ search, page, limit, organisationId });

    if (!res.ok) {
      return { ok: false, data: { count: 0, list: [] }, status: res.status };
    }

    const payload = res.data || {};
    const list = Array.isArray(payload) ? payload : (payload.list || []);
    const normalized = list.map((item) => normalizeProfile(item)).filter(Boolean);

    return {
      ok: true,
      data: normalizeProfileList({
        count: Number(payload.count) || normalized.length,
        list: normalized,
      }),
      status: res.status,
    };
  },

  async getProfileById(profileId) {
    const res = await rbacService.getProfileById(profileId);
    if (!res.ok) {
      return { ok: false, data: null, status: res.status };
    }
    return { ok: true, data: normalizeProfile(res.data), status: res.status };
  },

  async createProfile(payload) {
    const res = await rbacService.createProfile(payload);
    return {
      ...res,
      data: normalizeProfile(res.data),
    };
  },

  async updateProfile(profileId, payload) {
    const res = await rbacService.updateProfile(profileId, payload);
    return {
      ...res,
      data: normalizeProfile(res.data),
    };
  },

  async deleteProfile(profileId) {
    return rbacService.deleteProfile(profileId);
  },

  async cloneProfile(payload) {
    const res = await rbacService.cloneProfile(payload);
    return {
      ...res,
      data: normalizeProfile(res.data),
    };
  },
};

export default profileService;
